import {Vue} from '~/addiesaas'

import ReCartBillingSectionFisExpress from './re-cart-billing-section-fis-express'
import ReCreditCardFormFisExpress from './re-credit-card-form-fis-express'

Vue.component(ReCartBillingSectionFisExpress.name, ReCartBillingSectionFisExpress)
Vue.component(ReCreditCardFormFisExpress.name, ReCreditCardFormFisExpress)

export default {
    ReCartBillingSectionFisExpress,
    ReCreditCardFormFisExpress,
}
